export const MAX_LOGO_EXPORT_LIMIT = 1000;

/** Consensus visualisation height */
export const CONSENSUS_HEIGHT = 24;

/** Conservation visualisation height */
export const CONSERVATION_HEIGHT = 80;

/** Sequence logo visualisation height */
export const LOGO_HEIGHT = 80;
